<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular
        color="primary"
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <div class="erro" v-if="mensagemErro">
      <h4>{{ mensagemErro }}</h4>
    </div>
    <div v-if="mostraDocumento">
      <meu-painel>
        <div ref="content" class="justificado">
          <!-- <h3 class="centralizado">
            AUTORIZAÇÃO PARA CONSULTA AO SISTEMA DE INFORMAÇÃO DE CRÉDITO (SCR)
          </h3> -->
          <h3 class="centralizado">
            AUTORIZAÇÃO PARA CONSULTA SCR E CADASTRO
          </h3>
          <br />
          <br />
          <p>
            Eu, <b>{{ dadosProdutor.producer_name.toUpperCase() }}</b
            >, inscrito(a) no CPF/MF sob o nº
            {{ formatCpf(dadosProdutor.producer_tax_id) }}, em virtude de
            operação de crédito, de qualquer natureza, pleiteada junto à empresa
            <b>{{ dadosProdutor.requester_company.toUpperCase() }}</b
            >, inscrita no CNPJ
            {{ formatCnpj(dadosProdutor.requester_company_tax_id) }}, e suas
            filiais, autorizo à <b>NAGRO CRÈDITO AGRO LTDA.</b>, inscrita no
            CNPJ sob o nº 22.165.622/0001-02, a consultar, a qualquer tempo, os
            débitos e responsabilidades decorrentes de operações com
            características de crédito e as informações e os registros de
            medidas judiciais que em meu nome e de minhas empresas, que constem
            ou venham a constar do Sistema de Informações de Crédito (SCR),
            gerido pelo Banco Central do Brasil - Bacen, ou dos sistemas que
            venham a complementá-lo ou a substituí-lo.

            <br />Autorizo também à <b>NAGRO CRÈDITO AGRO LTDA.</b> a
            compartilhar os dados desta consulta exclusivamente com a
            <b>{{ dadosProdutor.requester_company.toUpperCase() }}</b
            >, na qual estou pleiteando operação de crédito, de qualquer
            natureza.
          </p>
          <p>Declaro ainda, ser de meu conhecimento que:</p>
          <p>
            1. As consultas em meu nome no SCR poderão ser realizadas com base
            na presente autorização;
          </p>
          <p>
            2. O SCR tem por finalidades prover informações ao Banco Central do
            Brasil, para fins de monitoramento e supervisão a que estão expostas
            do crédito no sistema financeiro e para o exercício de suas
            atividades de fiscalização e propiciar o intercâmbio de informações
            entre instituições financeiras com o objetivo de subsidiar decisões
            de crédito e de negócios, conforme definido no § 1º do art. 1º da
            Lei Complementar nº 105, de 10 de janeiro de 2001, sobre o montante
            de responsabilidades de clientes em operações de crédito;
          </p>
          <p>
            3. Poderei ter acesso aos dados constantes em meu nome no SCR por
            meio do sistema “registrato” do Banco Central do Brasil - Bacen;
          </p>
          <p>
            4. Pedidos de correções, de exclusões e de manifestações de
            discordância quanto às informações constantes do SCR deverão ser
            dirigidas ao BACEN ou à instituição responsável pela remessa das
            informações, por meio de requerimento escrito e fundamentado, ou,
            quando for o caso, pela respectiva decisão judicial;
          </p>
          <p>
            5. mais informações sobre o SCR poderei obter em consulta a página
            na internet do Banco Central: www.bcb.gov.br
          </p>
          <br />
          <br />
          <p class="centralizado">
            Uberlândia (MG), {{ date.dia }} de {{ date.mes }} de {{ date.ano }}
          </p>
          <br />
          <br />
          <br />
          <p class="centralizado">______________________________________</p>
          <div class="dados">
            <p class="centralizado">
              Nome: <b>{{ dadosProdutor.producer_name.toUpperCase() }}</b>
            </p>
            <br />
            <p class="centralizado">
              CPF: {{ formatCpf(dadosProdutor.producer_tax_id) }}
            </p>
          </div>
        </div>
      </meu-painel>

      <div class="botao">
        <v-btn
          :loading="loading"
          class="sombra"
          @click="gerarPdf()"
          color="primary"
          >Gerar pdf para impressão</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Painel from "../../components/Painel.vue";
import api from "../../services/api";
import dadosProdutor from "../../models/dadosProdutor";

export default {
  components: {
    "meu-painel": Painel,
  },

  data() {
    return {
      dadosProdutor: new dadosProdutor(),
      overlay: true,
      mostraDocumento: false,
      mensagemErro: "",
      date: {},
      loading: false,
    };
  },

  created() {
    const data = new Date();

    const meses = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];

    this.date = {
      dia: data.getDate(),
      mes: meses[data.getMonth()],
      ano: data.getFullYear(),
    };
  },

  mounted() {
    api
      .get(`/producers-api/${this.$route.params.producer_data}`)
      .then((response) => {
        this.dadosProdutor = response.data;
        this.mostraDocumento = true;
        this.overlay = false;
        localStorage.setItem("produtor", JSON.stringify(this.dadosProdutor));
      })
      .catch((err) => {
        this.mensagemErro =
          "Não foi possivel conectar com o servidor! Entre em contato com a Nagro.";
        this.overlay = false;

        if (err.response.status === 400) {
          this.mensagemErro = "";
          this.mensagemErro = err.response.data.error;
          this.overlay = false;
        }
      });
  },

  methods: {
    formatCpf(cpf) {
      try {
        cpf = cpf.replace(/\D/g, "");
        cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
        cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
        cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        return cpf;
      } catch (error) {
        this.mensagemErro =
          "Não foi possível formatar o CPF. Verifique se o CPF é válido!";
        this.overlay = false;
        this.mostraDocumento = false;
      }
    },
    formatCnpj(cnpj) {
      try {
        cnpj = cnpj.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          "$1.$2.$3/$4-$5"
        );
        return cnpj;
      } catch (error) {
        this.mensagemErro =
          "Não foi possível formatar o CNPJ. Verifique se o CNPJ é válido!";
        this.overlay = false;
        this.mostraDocumento = false;
      }
    },
    async gerarPdf() {
      // html2canvas(this.$refs.content, { scale: 2 }).then((canvas) => {
      //   let pdf = new jsPDF({
      //     unit: "px",
      //     format: "a4",
      //   });
      //   pdf.addImage(canvas.toDataURL("image/png"), "JPEG", 40, 15, 360, 0);
      //   pdf.save("SCR - " + this.dadosProdutor.producer_name + ".pdf");
      // });

      const data = {
        name: this.dadosProdutor.producer_name.toUpperCase(),
        doc_num: this.formatCpf(this.dadosProdutor.producer_tax_id),
        company_name: this.dadosProdutor.requester_company.toUpperCase(),
        company_doc_num: this.formatCnpj(
          this.dadosProdutor.requester_company_tax_id
        ),
      };

      this.loading = true;

      try {
        const response = await api.post(
          "https://scr-pdf-release-sn5bjhlgya-uc.a.run.app/generate-pdf",
          data
        );

        if (!!response.data && !!response.data.file) {
          const b64 = response.data.file;
          const link = document.createElement("a");
          link.innerHTML = "Download PDF file";
          link.download = "SCR - " + this.dadosProdutor.producer_name + ".pdf";
          link.href = "data:application/octet-stream;base64," + b64;
          link.click();

          this.$router.push({ name: "uploadDoc" });
        }
      } catch (error) {
        // console.log(error.request);
      }

      this.loading = false;
    },
  },
};
</script>

<style>
.home {
  padding-top: 20px;
}

.botao {
  position: fixed;
  bottom: 10px;
  margin: 0 auto;
  width: 100%;
}

.centralizado {
  text-align: center;
}

.justificado {
  text-align: justify;
  text-justify: inter-word;
}

.erro {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.dados {
  width: 60%;
  margin: 30px auto 30px auto;
}
</style>
